import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { DealDocument } from '_business/types/TransactionsDocuments';
import { extractDocumentName } from '_technical/views/projects/Details/DealDocuments/document-format';
import {
  getFileIcon,
  SendBy,
} from '_technical/views/projects/Details/DealDocuments/DealDocumentsTable';
import { useDownloadDocument } from 'views/projects/products_hooks';
import humanFileSize from '_technical/utils/fileSize';

interface FileLineProps {
  file: DealDocument;
  className?: string;
}

const FileLine: React.FC<FileLineProps> = ({ file, className }) => {
  const { t } = useTranslation('documents');
  const { download, loading } = useDownloadDocument();

  const fileInfos = `${file.extension} - ${humanFileSize(file.size)}`;

  const handleDownload = () => {
    download(file.id);
  };

  return (
    <tr className={className}>
      <td className={'flex items-start gap-1 pb-3'}>
        <span className={'text-primary hidden lg:inline'}>
          {getFileIcon(file.extension)}
        </span>
        <span className={''}>
          <p className={'flex flex-col gap-1'}>
            <button
              onClick={handleDownload}
              disabled={loading}
              className={clsx(
                'text-xs underline line-clamp-1 text-ellipsis text-left p-0 border-none bg-transparent cursor-pointer transition-colors',
                loading
                  ? 'text-GrisHellio-5 cursor-not-allowed'
                  : 'text-primary hover:text-primary/80',
              )}
            >
              {extractDocumentName(file.name)}
            </button>
            <SendBy item={file} />
            <span
              className={'text-xs uppercase text-GrisHellio-5 block lg:hidden'}
            >
              {fileInfos}
            </span>
          </p>
        </span>
      </td>
      <td>
        <span className={'text-xs uppercase text-GrisHellio-5 hidden lg:block'}>
          {fileInfos}
        </span>
      </td>
      <td>
        <div className={clsx('flex justify-end w-full')}>
          <Button
            onClick={handleDownload}
            loading={loading}
            disabled={loading}
            title={t('download')}
            className={'text-primary border-none'}
            icon={<DownloadOutlined />}
          />
        </div>
      </td>
    </tr>
  );
};

export default FileLine;
